import React from 'react';

const ArtistContentMainQuote = (props:any) => {
const quote = props.artistQuote;

return (
    <div className={'mb-2 text-gray-500'} data-grid-artist-quote="true" dangerouslySetInnerHTML={{__html:quote}}>
    </div>
)
}

export default ArtistContentMainQuote;